import { Radio, RadioGroup } from '@headlessui/react'
import clsx from 'clsx'
import { ReactElement, ReactNode } from 'react'

type Option<T> = {
  name: string | ReactElement
  value: T
  content?: ReactNode
}
type BaseRadioGroupProps<T> = {
  value: T
  options: Option<T>[]
  onChange: (value: T) => void
  className?: string
  disabled?: boolean
}

export const BaseRadioGroup = <T extends string | number>({
  options,
  value,
  onChange,
  className,
  disabled,
}: BaseRadioGroupProps<T>) => {
  const handleChange = (option: T) => {
    if (onChange) {
      onChange(option)
    }
  }

  return (
    <div className="w-full">
      <div className="mx-auto w-full max-w-md">
        <RadioGroup
          value={value}
          onChange={handleChange}
          aria-label="Base Radio Group"
          className={clsx('space-y-2', className)}
        >
          {options.map((option) => (
            <Radio
              key={option.value}
              value={option.value}
              disabled={disabled}
              className="group flex flex-col bg-white dark:bg-dark-bg px-3 py-3 border border-card-border data-[checked]:border-primary data-[checked]:dark:border-primary-dark dark:border-card-border-dark rounded-lg data-[focus]:outline-1 data-[focus]:outline-white focus:outline-none placeholder-text-secondary text-text-secondary transition cursor-pointer"
            >
              <span className="flex justify-between items-center w-full">
                <span className="text-sm/6">
                  <span className="text-text-main dark:text-white group-data-[checked]:dark:text-primary-dark group-data-[checked]:text-primary">
                    {option.name}
                  </span>
                </span>
                <span className="flex justify-center items-center border group-data-[checked]:border-primary group-data-[checked]:dark:border-primary rounded-full w-5 h-5 shrink-0">
                  <span className="hidden group-data-[checked]:block bg-primary dark:bg-primary-dark rounded-full w-[14px] h-[14px] transition"></span>
                </span>
              </span>

              {value === option.value && option.content && (
                <div className="mt-4 w-full">{option.content}</div>
              )}
            </Radio>
          ))}
        </RadioGroup>
      </div>
    </div>
  )
}
